
import { Component, Vue } from 'vue-property-decorator';
import Clipboard from 'v-clipboard';
import VueToast from 'vue-toasted';
import Form from '@/components/Form/Form.vue';
import { duplicateInvoice } from '@/utils/api';
import InputField from '@/types/InputField';
import * as constants from './constants';
import { TOAST_OPTIONS } from '@/utils/sharedOptions';

Vue.use(Clipboard);
Vue.use(VueToast, TOAST_OPTIONS);
@Component({
  components: {
    Form,
  },
})

export default class CopyInvoiceForm extends Vue {
  public copyCanceledInvoiceInput: string = '';

  public constants: object = constants;
  public resetLeadError: null | string = null;
  public cancelInvoiceError: null | string = null;
  public cancelInvoiceFields: InputField[] = [
    {
      placeholder: constants.COPY_INVOICE_PLACEHOLDER,
      updateInput: this.updateCancelInput,
      type: 'text',
      key: constants.COPY_INVOICE_PLACEHOLDER,
  },
];
  private $clipboard: any;

  public updateCancelInput(input: string): void {
    this.copyCanceledInvoiceInput = input;
  }

  public async copyInvoice(): Promise<void> {
    this.cancelInvoiceError = null;
    try {
      const invoiceLink: string = await duplicateInvoice(this.copyCanceledInvoiceInput);
      this.$clipboard(invoiceLink);
      window.open(invoiceLink, '_blank');
      this.$toasted.show(constants.COPIED_TO_CLIPBOARD, TOAST_OPTIONS);
    } catch (error) {
      this.cancelInvoiceError = error.message;
    }
  }

}
